import { BlogArticlesList } from './BlogArticlesList/BlogArticlesList';
import Pagination from 'components/Blocks/Pagination/Pagination';
import { getEndCursor } from 'components/Blocks/Pagination/paginationHelpers';
import { BLOG_CATEGORY_PAGE_SIZE } from 'config/constants';
import { mapBlogArticleConnection, usePromotedBlogArticle } from 'connectors/articleInterface/blogArticle/BlogArticle';
import { useBlogCategoryArticlesApi } from 'graphql/generated';
import { useCurrentLoadMoreQuery } from 'helpers/queryParams/useCurrentLoadMoreQuery';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useListingForPagination } from 'hooks/ui/useListingForPagination';
import { useRef } from 'react';
import { ListedBlogArticleType } from 'types/blogArticle';

type BlogCategoryArticlesWrapperProps = {
    uuid: string;
};

export const BlogCategoryArticlesWrapper: FC<BlogCategoryArticlesWrapperProps> = ({ uuid }) => {
    const promotedArticle = usePromotedBlogArticle(uuid);
    const paginationScrollTargetRef = useRef<null | HTMLDivElement>(null);
    const currentPage = useCurrentPageQuery();
    const currentLoadMore = useCurrentLoadMoreQuery();

    const [{ data }] = useBlogCategoryArticlesApi({
        variables: {
            uuid,
            endCursorForPagination: getEndCursor(currentPage, currentLoadMore, BLOG_CATEGORY_PAGE_SIZE),
        },
    });

    const [dataItems, isLoading] = useListingForPagination<ListedBlogArticleType>(
        data?.blogCategory?.blogArticles.edges
            ? mapBlogArticleConnection(data.blogCategory.blogArticles)?.edges ?? []
            : [],
        currentLoadMore > 0,
    );

    return (
        <>
            <BlogArticlesList
                blogArticles={dataItems}
                promotedArticle={promotedArticle}
                showPromotedArticle={currentPage === 1}
            />
            <Pagination
                paginationScrollTargetRef={paginationScrollTargetRef}
                isBlogCategory
                pageSize={BLOG_CATEGORY_PAGE_SIZE}
                isLoading={isLoading}
                isWithLoadMore
                totalCount={data?.blogCategory?.blogArticles.totalCount ?? 0}
            />
        </>
    );
};
